var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconHour(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "hour_icon",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_228",
    "data-name": "Rect\\xE1ngulo 228",
    width: 34,
    height: 34,
    transform: "translate(939 649)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Enmascarar_grupo_39",
    "data-name": "Enmascarar grupo 39",
    transform: "translate(-939 -649)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "FontAwsome_clock_",
    "data-name": "FontAwsome (clock)",
    d: "M24.089,8A16.089,16.089,0,1,0,40.178,24.089,16.086,16.086,0,0,0,24.089,8Zm0,29.064A12.975,12.975,0,1,1,37.064,24.089,12.971,12.971,0,0,1,24.089,37.064ZM28.1,30.291l-5.508-4a.784.784,0,0,1-.318-.629V15.006a.781.781,0,0,1,.778-.778h2.076a.781.781,0,0,1,.778.778V24.2l4.334,3.153a.778.778,0,0,1,.169,1.09l-1.22,1.68A.784.784,0,0,1,28.1,30.291Z",
    transform: "translate(931.911 641.911)",
    fill: "#b1cb79"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHour);
export default __webpack_public_path__ + "static/media/icon_hour.3c379b9050fb7c434926f0425ba46291.svg";
export { ForwardRef as ReactComponent };